import {useKeycloak} from "@react-keycloak/web";
import React, {ReactNode} from "react";
import Button from '@mui/material/Button';

export const LoginLogoutView = (
  {
    login,
    logout,
    loginLabel,
    logoutLabel,
    authenticated,
    children,
  }: {
    login: () => void,
    logout: () => void,
    loginLabel: string,
    logoutLabel: string,
    authenticated: boolean| undefined,
    children?: ReactNode,

  }) => {


  return <>
    {!authenticated && (
      <Button variant="outlined" onClick={(e) => login()}>{loginLabel}</Button>
    )}
    {authenticated && (
      <Button variant="outlined"  type="button" onClick={() => logout()}>
        {logoutLabel}
      </Button>
    )}
    {children}
  </>
}

export function LoginLogoutContainer({loginLabel, logoutLabel}:
                                {
                                  loginLabel?: string,
                                  logoutLabel?: string,
                                  children?: React.ReactNode
                                }) {
  const {keycloak, initialized} = useKeycloak()

  const login = () => {
    localStorage.clear()
    keycloak.login({idpHint: window.FRONT_CONFIG.oauth.idpHint})
  }

  const logout = () => {
    localStorage.clear()
    keycloak.logout()
  }

  return (
    <LoginLogoutView login={login}
                     logout={logout}
                     loginLabel={loginLabel ? loginLabel : 'Login'}
                     logoutLabel={logoutLabel ? logoutLabel : 'Logout'}
                     authenticated={keycloak.authenticated}/>

  );
}

